export default __webpack_public_path__ + "static/media/Sm.3f0e8214.png";